import { render, staticRenderFns } from "./NorthBeaches.vue?vue&type=template&id=74ca5312&scoped=true&"
import script from "./NorthBeaches.vue?vue&type=script&lang=js&"
export * from "./NorthBeaches.vue?vue&type=script&lang=js&"
import style0 from "./NorthBeaches.vue?vue&type=style&index=0&id=74ca5312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca5312",
  null
  
)

export default component.exports